function processCountdownNumbers($fake, time) {
    fillCountdownNumbers($fake.find('.js-days'), time.days);
    fillCountdownNumbers($fake.find('.js-hours'), time.hours);
    fillCountdownNumbers($fake.find('.js-minutes'), time.minutes);
    fillCountdownNumbers($fake.find('.js-seconds'), time.seconds);
}

function fillCountdownNumbers($item, time) {
    var $numbers = $item.find('.is-numbers'),
        splittedTime = time.toString().split('');

    if (splittedTime.length == 1) {
        splittedTime.unshift('0');
    }

    if ($numbers.text() != time) {
        $numbers.empty();

        $.each(splittedTime, function () {
            $numbers.append('<span>' + this + '</span>');
        });
    }
}

function setCountdown($element, time, format) {
    if (!$element.hasClass('is-loaded')) {
        $element.addClass('is-loaded');

        $element.countdown(time, function (event) {
            if (typeof format == 'undefined') {
                if (event.offset.totalDays > 0) {
                    format = '%d <span>d</span> : %H <span>h</span> : %M <span>min</span>';
                } else {
                    format = '%H <span>h</span> : %M <span>min</span> : %S <span>s</span>';
                }
            }

            if ($element.siblings('.js-countdown-fake').length) {
                format = '';
            } else {
                $(this).html(event.strftime(format));
            }
        });
    }
}

$(function() {
    $('.js-countdown').each(function () {
        setCountdown($(this), $(this).attr('data-time'));
    });

    $('.js-countdown-custom').each(function () {
        processCountdownNumbers($(this).find('.js-countdown-fake'), {
            days: '--',
            hours: '--',
            minutes: '--',
            seconds: '--'
        });
    })

    $(document).on('update.countdown finish.countdown', '.js-countdown-custom .js-countdown', function (event) {
        var $fake = $(this).siblings('.js-countdown-fake'),
            times = {
                days: '00',
                hours: '00',
                minutes: '00',
                seconds: '00'
            };

        if (event.type == 'update') {
            times = {
                days: event.offset.totalDays,
                hours: event.offset.hours,
                minutes: event.offset.minutes,
                seconds: event.offset.seconds
            };
        }

        processCountdownNumbers($fake, times);
    });
});